<template>
	<div class="modal-card" style="width: auto; min-width: 680px">
		<header class="modal-card-head">
			<p class="modal-card-title">Add Widget</p>
		</header>
		<section class="modal-card-body">
			<o-field label="Widget Type">
				<o-select v-model="sectionType" placeholder="Widget Type">
					<option value="OlympusRichText">Rich Text (Html)</option>
					<option v-for="option in componentOptions" :key="option" :value="option">
						{{ sectionTypes[option] }}
					</option>
				</o-select>
			</o-field>
			<div class="mt-2" v-if="sectionType">
				<o-field label="Title" message="The title that will display on this card.">
					<o-input v-model="section.title" type="text"></o-input>
				</o-field>
				<o-field label="Column Width" message="The column span for this field.">
					<o-select v-model="section.columnWidth">
						<option :value="null">Auto</option>
						<!-- <option :value="1">8%&nbsp;(1/12)</option>
						<option :value="2">16%&nbsp;(1/6)</option>
						<option :value="3">25%&nbsp;(1/4)</option>
						<option :value="4">33%&nbsp;(1/3)</option>
						<option :value="5">42%&nbsp;(5/12)</option> -->
						<option :value="6">50%&nbsp;(1/2)</option>
						<!-- <option :value="7">58%&nbsp;(7/12)</option>
						<option :value="8">66%&nbsp;(2/3)</option>
						<option :value="9">75%&nbsp;(3/4)</option>
						<option :value="10">83%&nbsp;(5/6)</option>
						<option :value="11">92%&nbsp;(11/12)</option> -->
						<option :value="12">100%</option>
					</o-select>
				</o-field>

				<o-field
					v-if="isPagePromotion"
					label="To"
					message="The internal name of the promoted page.">
					<o-input v-model="section.toVueRouterName" type="text"></o-input>
				</o-field>
				<o-field label="Min Width" message="The minimum width in REMs." v-if="false">
					<o-input v-model="section.minWidth" type="number"></o-input>
				</o-field>
			</div>
		</section>
		<footer class="modal-card-foot">
			<o-button variant="success" :disabled="saving || !sectionType" @click="Add">
				Add widget
			</o-button>
			<o-button variant="light" @click="Back">Back</o-button>
		</footer>
	</div>
</template>
<script>
	import { ref, computed, inject, onMounted } from "vue";
	import { Editors } from "@/services/utils/ckeditor";
	export default {
		setup(props, context) {
			const section = ref({
				columnWidth: 12
			});
			const editor = ref(Editors.Default);
			const saving = ref(false);
			const sectionType = ref("");
			const sectionTypes = inject("$olympusSections");
			const componentOptions = Object.keys(sectionTypes);

			const isRichText = computed(() => {
				return sectionType.value === "OlympusRichText";
			});
			const isPagePromotion = computed(() => {
				return sectionType.value === "OlympusPagePromotion";
			});
			const isVueComponent = computed(() => {
				return !!componentOptions.find((o) => o === sectionType.value);
			});

			const Back = () => {
				context.emit("close");
			};
			const Add = () => {
				if (isRichText.value) {
					section.value.contentType = "OlympusRichText";
				} else if (isPagePromotion.value) {
					section.value.contentType = "OlympusPagePromotion";
				} else {
					section.value.contentType = "OlympusVueComponent";
				}
				section.value.componentType = isVueComponent.value ? sectionType.value : "";
				context.emit("add", { section: section.value, close: Back });
			};

			return {
				saving,
				sectionType,
				sectionTypes,
				componentOptions,
				section,
				editor,
				isRichText,
				isPagePromotion,
				isVueComponent,
				Add,
				Back
			};
		}
	};
</script>
